import React from 'react';
import * as Mui from '@mui/material';
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as Icons from 'react-feather';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { styles } from './style';
import { Agent } from "model/agent";
import { Select } from "component/shared/select";
import { PhotoUploadDialogButton } from "component/shared/photo-upload-dialog-button";
import { Avatar } from "component/shared/avatar";
import { RootState, getPayload } from "redux/store";
import { updateAgent } from "redux/slice/agents"
import { SaveButton } from "component/shared/save-button";
import * as env from "shared/env";

interface Props extends OwnProps,
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	WithStyles<typeof styles> {}

interface OwnProps {
	agent: Agent;
	onClose: () => void;
}

interface State {
	photoSource: "photoUrl" | "uploadPhoto",
	photoUrl: string,
	openSnackbar: boolean,
	snackbarMessage: string,
	snackbarSeverity: string,
	submitted: boolean;
}

const mapStateToProps = (state: RootState, ownProps: OwnProps) => {
	return {
		loading: state.agents.loading,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(
		{
			updateAgent,
		},
		dispatch
	);
};

class Component extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			photoSource: this.props.agent.photoUrl ? "photoUrl" : "uploadPhoto",
			photoUrl: this.props.agent.photoUrl ? this.props.agent.photoUrl : "",
			openSnackbar: false,
			snackbarMessage: "",
			snackbarSeverity: "",
			submitted: false,
		};
	}

	private async save() {
		const { updateAgent, agent, onClose } = this.props;
		const { photoUrl } = this.state;
		const agentResource = getPayload( await updateAgent( { agent: {
			...agent,
			photoUrl,
		}}));
		if (agentResource) {
			onClose();
		}
	}

	private uploadCallback = (uploads: any[]) => {
		const upload = uploads.find((upload) => upload.url);
		if (upload && upload.url) {
			this.setState({
				photoSource: "photoUrl",
				photoUrl: upload.url,
				openSnackbar: true,
				snackbarMessage: "Upload Successful",
				snackbarSeverity: "success",
			});
		} else {
			this.setState({
				openSnackbar: true,
				snackbarMessage: "Error",
				snackbarSeverity: "error",
			});
		}
	};

	render() {
		const { photoSource, photoUrl, submitted } = this.state;
		const { loading, classes = {} } = this.props;

		return (
			<Mui.Grid container direction="column" spacing={2}>
				<Mui.Grid item>
					<Mui.Typography>Choose how to add your profile photo:</Mui.Typography>
				</Mui.Grid>
				<Mui.Grid item>
					<Mui.RadioGroup
						value={photoSource}
						onChange={(e) => this.setState({ photoSource: e.target.value as "photoUrl" | "uploadPhoto" })}
					>
						<Mui.FormControlLabel
							value="photoUrl"
							control={<Mui.Radio color="secondary" />}
							label="Photo URL"
						/>
						{photoSource === "photoUrl" && (
							<Mui.TextField
								fullWidth
								inputProps={{ maxLength: 100 }}
								label="Photo URL"
								margin="dense"
								onChange={(event) => this.setState({ photoUrl: event.target.value })}
								value={photoUrl}
								variant="outlined"
							/>
						)}
						<Mui.FormControlLabel
							value="uploadPhoto"
							control={<Mui.Radio color="secondary" />}
							classes={{ root: classes.uploadFormControl, label: classes.uploadLabel }}
							label={
								<>
									<Mui.Typography>Upload Photo</Mui.Typography>
									{photoSource === "uploadPhoto" && (
										<PhotoUploadDialogButton
											multiple={false}
											callback={this.uploadCallback}
											label="Upload Photo"
											resourceType="image"
											variant="outlined"
											color="primary"
											icon={<Icons.Upload size={16} />}
										/>
									)}
								</>
							}
						/>
					</Mui.RadioGroup>
				</Mui.Grid>
				<Mui.Grid item>
					<Mui.Grid container spacing={1} justifyContent="flex-end">
						<Mui.Grid item>
							<Mui.Button
								className={classes.button}
								variant="outlined"
								color="primary"
								onClick={() => this.props.onClose()}
							>
								Cancel
							</Mui.Button>
						</Mui.Grid>
						<Mui.Grid item>
							<Mui.Button
								className={classes.button}
								variant="contained"
								color="primary"
								onClick={() => {
									this.setState({ submitted: true });
									this.save();
								}}
							>
								Save
							</Mui.Button>
						</Mui.Grid>
					</Mui.Grid>
				</Mui.Grid>
			</Mui.Grid>
		);
	}
}

export const Photo = withStyles(connect(mapStateToProps, mapDispatchToProps)(Component), styles);
